import $ from 'jquery';
import anime from 'animejs';
import { scrollTo, getScrollInstance } from '../core/ScrollService.js';
const initSommaire = () => {
    const sommaireList = document.getElementById('sommaire-list');

    if (!sommaireList) return;

    // Récupérer tous les titres h2 et h3 dans le contenu de l'article
    // Chercher d'abord dans les sélecteurs spécifiques
    let articleContent = document.querySelector('.flex-content, .wysiwygStyle, .entry-content');
    const wysiwygFound = [];
    if (articleContent && (articleContent.matches && articleContent.matches('.flex-content, .wysiwygStyle, .entry-content'))) {
        wysiwygFound.push(articleContent);
    }

    // Si pas trouvé, chercher dans toutes les sections entre le sommaire et pSection--articles
    if (!articleContent) {
        const sommaireSection = document.querySelector('.article-sommaire');
        const articlesSection = document.querySelector('.pSection--articles');

        if (sommaireSection && articlesSection) {
            // Récupérer toutes les sections entre le sommaire et la section articles
            const allSections = document.querySelectorAll('section, .pSection, .bloc');
            let targetSections = [];
            let foundSommaire = false;

            for (let section of allSections) {
                if (section === sommaireSection) {
                    foundSommaire = true;
                    continue; // Ignorer la section sommaire elle-même
                }
                if (section === articlesSection) {
                    break; // Arrêter à la section articles
                }
                if (foundSommaire) {
                    targetSections.push(section);
                }
            }

            // Créer un conteneur temporaire pour chercher les titres
            if (targetSections.length > 0) {
                const tempContainer = document.createElement('div');
                targetSections.forEach(section => {
                    tempContainer.appendChild(section.cloneNode(true));
                });
                articleContent = tempContainer;
            }
        }
    }

    // Construire la liste des titres à partir de plusieurs sources si besoin
    let headingList = [];
    if (articleContent) {
        headingList = Array.from(articleContent.querySelectorAll('h2, h3'));
        wysiwygFound.push(articleContent);
    }

    // Toujours chercher tous les h2/h3 dans toutes les sections entre sommaire et articles
    const sommaireSection = document.querySelector('.article-sommaire');
    const articlesSection = document.querySelector('.pSection--articles');
    if (sommaireSection && articlesSection) {
        // Trouver toutes les sections dans la plage
        const allSections = document.querySelectorAll('section, .pSection, .bloc, .flex-content, .wysiwygStyle, .entry-content');
        const sectionsFound = [];

        allSections.forEach(section => {
            // Vérifier si cette section est entre sommaire et articles
            if (sommaireSection.compareDocumentPosition(section) & Node.DOCUMENT_POSITION_FOLLOWING &&
                articlesSection.compareDocumentPosition(section) & Node.DOCUMENT_POSITION_PRECEDING) {

                sectionsFound.push(section);

                // Si c'est un WYSIWYG, l'ajouter à la liste des WYSIWYG
                if (section.matches && section.matches('.flex-content, .wysiwygStyle, .entry-content')) {
                    if (!wysiwygFound.includes(section)) {
                        wysiwygFound.push(section);
                    }
                }

                // Chercher tous les h2/h3 dans cette section
                const sectionHeadings = section.querySelectorAll('h2, h3');
                sectionHeadings.forEach(heading => {
                    if (!headingList.includes(heading)) {
                        headingList.push(heading);
                    }
                });
            }
        });

        // Log des sections trouvées
        console.log('[Sommaire] Sections trouvées entre sommaire et articles:', sectionsFound.map((el, i) => ({
            index: i + 1,
            tagName: el.tagName,
            className: el.className,
            headingsCount: el.querySelectorAll('h2, h3').length
        })));
    }

    if (headingList.length === 0) return;

    // Log des conteneurs WYSIWYG utilisés pour le sommaire
    try {
        if (wysiwygFound.length > 0) {
            console.log('[Sommaire] WYSIWYG trouvés:', wysiwygFound.map((el, i) => ({ index: i + 1, class: el.className, node: el })));
        } else {
            console.log('[Sommaire] Aucun conteneur WYSIWYG spécifique trouvé dans la plage considérée.');
        }
    } catch (e) { /* noop */ }

    // Vider le sommaire existant
    sommaireList.innerHTML = '';

    let currentH2Item = null;
    let h2Counter = 0;
    let h3Counter = 0;

    // Générer le sommaire avec structure hiérarchique
    headingList.forEach((heading, index) => {
        // Créer un ID unique pour l'ancre si il n'en a pas
        let anchorId = heading.id;
        if (!anchorId) {
            anchorId = `section-${index + 1}`;
            heading.id = anchorId;
        }

        if (heading.tagName === 'H2') {
            // Réinitialiser le compteur h3 pour chaque nouveau h2
            h3Counter = 0;
            h2Counter++;

            // Créer l'élément de liste principal (h2)
            currentH2Item = document.createElement('li');

            // Créer le container pour le numéro et le lien
            const itemContent = document.createElement('div');
            itemContent.className = 'sommaire-item-content';

            // Créer le span pour le numéro
            const numberSpan = document.createElement('span');
            numberSpan.className = 'sommaire-number';
            numberSpan.textContent = h2Counter + '.';

            const link = document.createElement('a');
            link.textContent = heading.textContent.trim();
            link.href = `#${anchorId}`;
            link.addEventListener('click', (e) => {
                e.preventDefault();

                // Scroll vers la section
                const targetElement = document.getElementById(anchorId);
                if (targetElement) {
                    const offset = 100; // Offset pour éviter que le titre soit caché par le header
                    const targetPosition = targetElement.offsetTop - offset;

                    if (getScrollInstance()) {
                        scrollTo(targetElement, -180);
                    } else {
                        // Fallback pour les navigateurs sans Locomotive Scroll
                        window.scrollTo({
                            top: targetPosition,
                            behavior: 'smooth'
                        });
                    }
                }
            });

            itemContent.appendChild(numberSpan);
            itemContent.appendChild(link);
            currentH2Item.appendChild(itemContent);
            sommaireList.appendChild(currentH2Item);

        } else if (heading.tagName === 'H3' && currentH2Item) {
            h3Counter++;

            // Créer une sous-liste pour les h3
            let subList = currentH2Item.querySelector('ol');
            if (!subList) {
                subList = document.createElement('ol');
                subList.className = 'sommaire-sublist';
                currentH2Item.appendChild(subList);
            }

            // Créer l'élément de sous-liste (h3)
            const subListItem = document.createElement('li');

            // Créer le span pour le numéro de sous-section
            const subNumberSpan = document.createElement('span');
            subNumberSpan.className = 'sommaire-subnumber';
            subNumberSpan.textContent = h2Counter + '.' + h3Counter + '.';

            const subLink = document.createElement('a');
            subLink.textContent = heading.textContent.trim();
            subLink.href = `#${anchorId}`;
            subLink.addEventListener('click', (e) => {
                e.preventDefault();

                // Scroll vers la section
                const targetElement = document.getElementById(anchorId);
                if (targetElement) {
                    const offset = 100; // Offset pour éviter que le titre soit caché par le header
                    const targetPosition = targetElement.offsetTop - offset;

                    if (getScrollInstance()) {
                        scrollTo(targetElement, -180);
                    } else {
                        // Fallback pour les navigateurs sans Locomotive Scroll
                        window.scrollTo({
                            top: targetPosition,
                            behavior: 'smooth'
                        });
                    }
                }
            });

            subListItem.appendChild(subNumberSpan);
            subListItem.appendChild(subLink);
            subList.appendChild(subListItem);
        }
    });
};

export { initSommaire };
